
import {Vue, Component} from 'vue-property-decorator';
import {ApplicationModule} from "@/store";
import accounting from "accounting";

@Component({})
export default class VehicleBanner extends Vue {
	vehicle = ApplicationModule.vehicle;

	formatAsMoney(value:any) {
	return accounting.formatMoney(value, {
		symbol: '',
		precision: 0,
		thousand: ',',
		decimal: '.'
	}).replace('.00', '')
}
}
